import { render, staticRenderFns } from "./nft-row.vue?vue&type=template&id=20b21fdb&"
import script from "./nft-row.vue?vue&type=script&lang=js&"
export * from "./nft-row.vue?vue&type=script&lang=js&"
import style0 from "./nft-row.vue?vue&type=style&index=0&id=20b21fdb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports